/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { TableDatabase } from '../../lib/wwg.classes';
import { Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerComponent } from '../spinner/spinner.component';
import { AuthInterceptor } from "../../sdk/services/core/auth.interceptor"
import { DocumentApi } from "../../sdk/services/custom"

/**
 * Usage:
 * Component:
 * import { ViewChild } from '@angular/core';
 * import { FileuploaderComponent } from '../../../shared/components/fileuploader/fileuploader.component';
 * @ViewChild(FileuploaderComponent) FileUploader;
 * let uploadData = {
            baseUploadUrl: this.baseUploadUrl,
            streamId: ledger.id,
          };
 * this.FileUploader.uploadFiles(uploadData).then(() => {});
 *
 * HTML:
 * <wwg-fileuploader></wwg-fileuploader>
 */


@Component({
  selector: 'wwg-fileuploader',
  templateUrl: './fileuploader.component.html',
  styleUrls: ['./fileuploader.component.scss']
})
export class FileuploaderComponent implements OnInit {

  /**
   * Angular File Upload directive
   * @param  {object}
   * @return {FileUploader}
   */
  uploader: FileUploader = new FileUploader({
    headers: [
      {
        name: 'Authorization',
        value: AuthInterceptor.getAuthorizationHeaderValue()
      }
    ]
  });

  /**
   * Document Database (Table Management)
   * @param  {FileUploader} this.uploader
   * @return {TempDocsDatabase}
   */
  tempDocsDatabase = new TempDocsDatabase(this.uploader);

  /**
   * Document Database Source
   * @param  {DocsDataSource} this.tempDocsDatabase
   * @return {DocsDataSource}
   */
  docsDataSource: DocsDataSource = new DocsDataSource(this.tempDocsDatabase);

  /**
   * Document Table Definition
   * @type {Array<string>}
   */
  docsColumns: Array<string> = [
    'name',
    'title',
    'description',
    'action',
  ];

  constructor(
    private dialog: MatDialog,
    private DocumentApi: DocumentApi,
   ) { }

  ngOnInit() {
    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      item.withCredentials = false;
    };
    // Update uploader path to know who is getting the files
    this.uploader.setOptions({
      url: this.DocumentApi._generateURL(this.DocumentApi.endPoint)
    });
  }

  public uploadFiles(ownerId: string, ownerType: string): Promise<string> {
    return new Promise<string> ((resolve, reject) => {
      console.log("Uploading Documents");

      if (!ownerId) {
        reject('ownerId is not available');
      }

      // Add in the other upload form parameters.
      this.uploader.onBuildItemForm = (item: InternalFileItem, form: FormData) => {
        form.append('ownerId', ownerId);
        form.append('ownerType', ownerType);
        form.append('title', item.title);
        form.append('description', item.description);
      };

      try {
        // Upload Documents If there is any
        if (this.uploader.queue.length > 0) {
          this.showSpinner();
          this.uploader.uploadAll();
        } else {
          resolve('Ok');
        }

        // Generic Catch All notification for all files being uploaded.
        this.uploader.onCompleteAll = () => {
          this.dialog.closeAll();
          resolve('Ok');
        };
      } catch (err) {
        console.log("Failed to upload documents.");
        console.log(err);
        resolve(err);
      }

    });
  }

  /**
   * [showSpinner description]
   * @return {[type]} [description]
   */
  public showSpinner() {
    const dialog = this.dialog.open(SpinnerComponent, {
      height: '120px',
      width: '250px',
      data: {
        title: 'Uploading Files...'
      }
    });
  }

  saveChanges(row, title:string, description: string) {
    let i = this.tempDocsDatabase.data.length;


    console.log('tempDocsDatabase');
    console.log(this.tempDocsDatabase);

    /*while (i--) {
      let element = this.tempDocsDatabase.data[i];

      if (element)
    }*/
  }

}
class InternalFileItem extends FileItem {
  title: string = '';
  description: string = '';
}

export class TempDocsDatabase extends TableDatabase<object> {
  uploader: FileUploader;

  constructor(uploader) {
    super();
    this.uploader = uploader;

    this.uploader.onAfterAddingFile = (item: FileItem) => {
      // Internally file gets update with title, descriptions element
      this.add([{
        file: item,
        title: 'Click to set',
        description: 'Click to set'
      }]);
    };
  }

  remove(item: FileItem) {
    super.remove(item);
    this.uploader.removeFromQueue(item);
  }
}

/**
 * Shared datasource for file uploads appears to not be available for directive
 * @param  {TempDocsDatabase} private _tempDocsDatabase
 */
export class DocsDataSource extends DataSource<any> {
  constructor(private _tempDocsDatabase: TempDocsDatabase) {
    super();
  }

  connect(): Observable<any> {
    return this._tempDocsDatabase.dataChange;
  }

  disconnect() { }
}
